import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { TypedPolicies } from '../types';

import { queryKeys } from './query-keys';

export function usePolicies(options?: { refetchInterval?: number }) {
  return useQuery({
    queryKey: queryKeys.list(),
    queryFn: getPolicies,
    refetchInterval: options?.refetchInterval,
    ...withError('Unable to load policies'),
  });
}

async function getPolicies(): Promise<TypedPolicies> {
  try {
    const { data } = await axios.get<TypedPolicies>('/policies');
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve policies');
  }
}
